import React, { useState } from "react";
import styles from "./../../Styles/VideoStudy.module.scss";
import VideoBox from "../../Components/VideoBox";

const videoList_1 = [
  {
    id: 1,
    title: "The Captivating History of Scotland",
    duration: "11:29 mins",
    sourceLink: "https://www.youtube.com/embed/ouR6GeZrRUc?si=XQajAF-6RA2cTR1-"
  },
  {
    id: 2,
    title: "The Entire History of Scotland",
    duration: "25:27 mins",
    sourceLink: "https://www.youtube.com/embed/_PhX3dvmgko?si=lg3j7dHPC4Jow-C0"
  },
  {
    id: 3,
    title: "History of Scotland – Documentary",
    duration: "55:52 mins",
    sourceLink: "https://www.youtube.com/embed/cful8_-kQbE?si=OpHhODFo_8oAlwTv"
  },
  {
    id: 4,
    title: "How 6,000 Scots Defeated 20,000 English Knights at Bannockburn",
    duration: "26:30 mins",
    sourceLink: "https://www.youtube.com/embed/6bJ_LblHfIE?si=kjTxcRc2Qqg5r6l5"
  },
  {
    id: 5,
    title: "William Wallace, the Scottish Hero, Explained in 10 Minutes",
    duration: "10:49 mins",
    sourceLink: "https://www.youtube.com/embed/MFHwxqJrAdU?si=3dS0JtLlNhJLOlzS"
  },
  // {
  //   id: 6,
  //   title:
  //     "Lost Worlds: Braveheart&#39;s Scotland and William Wallace (S1, E11) | Full Episode | History",
  //   duration: "46:05 mins",
  //   sourceLink: ""
  // },
  {
    id: 7,
    title: "St Columba &amp; Iona Scotland",
    duration: "5:13 mins",
    sourceLink: "https://www.youtube.com/embed/yIdHlLaMflM?si=O4AZJfYJwhpWR2US"
  },
  {
    id: 8,
    title: "Columba &amp; Ireland&#39;s Golden Age",
    duration: "12:10 mins",
    sourceLink: "https://www.youtube.com/embed/4F-gI5FDxJM?si=DYjz64ltXdlt-OOa"
  },
  {
    id: 9,
    title: "John Knox – The Man Who Transformed Scotland Through Prayer",
    duration: "13:31 mins",
    sourceLink: "https://www.youtube.com/embed/Lj2mn0yw-xw?si=hOo0VF7oLmVZYjQR"
  },
  {
    id: 10,
    title:
      "Knox: The Life and Legacy of Scotland&#39;s Controversial Reformer | Full Documentary",
    duration: "1hr:17:39 mins",
    sourceLink: "https://www.youtube.com/embed/Bw3mzvtuO7A?si=41nnd5obn47xDNKg"
  },
  {
    id: 11,
    title: "The Scottish Highland: Rick Steves",
    duration: "25:01 mins",
    sourceLink: "https://www.youtube.com/embed/DDiq5C34KL4?si=6FsMfomH803PXcu9"
  },
  {
    id: 12,
    title: "Urquhart Castle",
    duration: "10:26 mins",
    sourceLink: "https://www.youtube.com/embed/tTXactmae7E?si=jJIuSwurCx9EnUM5"
  },
  {
    id: 13,
    title:
      "Scotland: Oban, Skye, and the Scottish Isles with Julia Reams-Giersch",
    duration: "10:22 mins",
    sourceLink: "https://www.youtube.com/embed/2Zgk7O429pE?si=EYfv2mAYInekHrWx"
  }
];

function VideoStudy() {
  const [modal, setModal] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  //const [videoLoading, setVideoLoading] = useState(true);

  const closeModal = () => {
    setModal(!modal);
  };

  return (
    <div className="pageContainer">
      <div className="title">Documentaries for the Scotland Tour</div>
      {/* <div className="secondaryTitle">Information to come...</div> */}
      <p className="text">
        You are invited/encouraged to watch these documentaries in the months
        prior to departure. It will add greatly to your experience/learning. I
        do not endorse everything said in these documentaries, but for the most
        part, I do.
      </p>
      {/* <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        Historical and cultural background
      </div> */}
      {videoList_1.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}
      {modal ? (
        <VideoBox closeModal={closeModal} videoLink={videoLink} />
      ) : null}
    </div>
  );
}

export default VideoStudy;
